import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import qs from "qs";
import {
  BasePagination,
  CustomError,
} from "./interfaces/commonInterface.interface";
import * as widgetInterface from "./interfaces/widgetInterface.interface";
import { DashboarAlertActiveResponse } from "./interfaces/dashboardInterface.interface";

const API_PATH = "/widget";

export const getWidgetAccountList = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.AccountList> => {
  try {
    const { data }: AxiosResponse<widgetInterface.AccountList> =
      await AxiosInstance.get(`${API_PATH}/account/list/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getDashboardRecorders = async ({
  accountId,
  includeSuspended,
}: {
  includeSuspended: boolean;
  accountId: string;
}): Promise<DashboarAlertActiveResponse> => {
  try {
    const res: AxiosResponse<DashboarAlertActiveResponse> =
      await AxiosInstance.get(
        `/dashboard/recorder/camera/type/${accountId}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
// ----------- Card API
export const getWidgetCountRecorder = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.GetWidgetRecorderResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetRecorderResponse> =
      await AxiosInstance.get(`${API_PATH}/recorder/count/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
export const getWidgetCountCamera = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.GetWidgetRecorderResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetRecorderResponse> =
      await AxiosInstance.get(`${API_PATH}/camera/count/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getWidgetChannelLicense = async (
  accountId: string
): Promise<widgetInterface.GetLicenseResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetLicenseResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/license/channel/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getWidgetCovaLicense = async (
  accountId: string
): Promise<widgetInterface.GetLicenseResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetLicenseResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/license/cova/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getWidgetEuLicense = async (
  accountId: string
): Promise<widgetInterface.GetLicenseResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetLicenseResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/license/eu/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getWidgetCountAlert = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.GetWidgetRecorderResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetRecorderResponse> =
      await AxiosInstance.get(`${API_PATH}/alert/count/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getWidgetCountAccount = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.GetWidgetRecorderResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetRecorderResponse> =
      await AxiosInstance.get(`${API_PATH}/account/count/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

// ------------- List API

export const getWidgetLoginHistory = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: BasePagination;
}): Promise<widgetInterface.GetWidgetLoginHistoryResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.GetWidgetLoginHistoryResponse> = await AxiosInstance.get(
      `${API_PATH}/loginHistory/${accountId}?${qs.stringify(payload)}`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getStatRecorder = async ({
  accountId,
  interval,
}: {
  accountId: string;
  interval: widgetInterface.GetStatInterval;
}): Promise<widgetInterface.GetWidgetStatsResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/stats/recorder/${accountId}/${interval}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postWidgetListRecorder = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayloadType;
}): Promise<widgetInterface.PostWidgetRecorderListResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.PostWidgetRecorderListResponse> = await AxiosInstance.post(
      `${API_PATH}/recorder/list/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postWidgetListAlert = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayloadType;
}): Promise<widgetInterface.PostWidgetAlertListResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.PostWidgetAlertListResponse> =
      await AxiosInstance.post(`${API_PATH}/alert/list/${accountId}`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postWidgetListAlertHistory = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayloadType;
}): Promise<widgetInterface.PostWidgetAlertHistoryListResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.PostWidgetAlertHistoryListResponse> = await AxiosInstance.post(
      `${API_PATH}/alert/history/list/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postWidgetInventoryRecorder = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayload;
}): Promise<widgetInterface.PostWidgetAlertListResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.PostWidgetAlertListResponse> =
      await AxiosInstance.post(
        `${API_PATH}/inventory/recorder/list/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
export const postWidgetInventoryCamera = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayloadType;
}): Promise<widgetInterface.PostWidgetInventoryCameraResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.PostWidgetInventoryCameraResponse> = await AxiosInstance.post(
      `${API_PATH}/inventory/camera/list/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postWidgetCvvDetection = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: widgetInterface.WidgetPayloadType;
}): Promise<widgetInterface.PostWidgetCvvDetectionResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.PostWidgetCvvDetectionResponse> = await AxiosInstance.post(
      `${API_PATH}/cvvDetection/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

/**
 *
 * stats API
 *
 */

export const postStatCloudStorage = async ({
  accountId,
  interval,
  payload,
}: {
  accountId: string;
  interval: widgetInterface.GetStatInterval;
  payload: widgetInterface.WidgetStatsPayload;
}): Promise<widgetInterface.GetWidgetCloudStorageResponse> => {
  try {
    const {
      data,
    }: AxiosResponse<widgetInterface.GetWidgetCloudStorageResponse> = await AxiosInstance.post(
      `${API_PATH}/stats/storage/${accountId}/${interval}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postStatCvv = async ({
  accountId,
  interval,
  payload,
}: {
  accountId: string;
  interval: widgetInterface.GetStatInterval;
  payload: widgetInterface.WidgetStatsPayload;
}): Promise<widgetInterface.GetWidgetCvvStatsResponse> => {
  try {
    const { data }: AxiosResponse<widgetInterface.GetWidgetCvvStatsResponse> =
      await AxiosInstance.post(
        `${API_PATH}/stats/cvv/${accountId}/${interval}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getDashboardPageViewCount = async (days: number) => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardCountResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/top5/list/${days}`);
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardDeviceCount = async (days: number) => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardCountResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/device/list/${days}`);
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardSummaryAccount = async ({
  accountId,
  includeSuspended,
}: widgetInterface.GetStatsSummaryPayload): Promise<widgetInterface.GetDashboardSummaryResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardSummaryResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/account/count/${accountId}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardSummaryRecorder = async ({
  accountId,
  includeSuspended,
}: widgetInterface.GetStatsSummaryPayload): Promise<widgetInterface.GetDashboardSummaryResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardSummaryResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/recorder/count/${accountId}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardSummaryCamera = async ({
  accountId,
  includeSuspended,
}: widgetInterface.GetStatsSummaryPayload): Promise<widgetInterface.GetDashboardSummaryResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardSummaryResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/camera/count/${accountId}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardSummaryUser = async ({
  accountId,
  includeSuspended,
}: widgetInterface.GetStatsSummaryPayload): Promise<widgetInterface.GetDashboardSummaryResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetDashboardSummaryResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/user/count/${accountId}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getActiveAlert = async ({
  accountId,
}: {
  accountId: string;
}): Promise<widgetInterface.GetActiveAlertResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetActiveAlertResponse> =
      await AxiosInstance.get(`${API_PATH}/dw/alert/count/${accountId}`);
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getCloudStorage = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsCloudStorageResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsCloudStorageResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/storage/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardUserLogin = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/login/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardVideoShare = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/videoShare/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardOrganization = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/org/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashabordOrganizationStatus = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/orgStatus/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardCamera = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/camera/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardRecorder = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/recorder/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardSubscription = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/key/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardUserStats = async ({
  accountId,
  interval,
  includeSuspended,
}: widgetInterface.GetStatsPayload): Promise<widgetInterface.GetStatsResponse> => {
  try {
    const res: AxiosResponse<widgetInterface.GetStatsResponse> =
      await AxiosInstance.get(
        `${API_PATH}/dw/stats/user/${accountId}/${interval}?isAll=${includeSuspended}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
